import type { SerialNumber } from "~domain/devices/models/common-device-model.ts";
import type { PilotConfSoftwareId, PilotCsId, PilotHwId } from "~domain/devices/models/pilot/pilot-model.ts";
import type { SiteId } from "~domain/sites/models/site-model.ts";

import { z } from "zod";

/**
 * void if 404....
 * Is it too much to ask backend devs to do things properly and return the correct status codes for what actually happened? Instead, we’re stuck dealing with this crap
 */
export const backofficeFindPilotResponseSchema = z.void().or(
  z.object({
    confSoftwareId: z.number().transform((s) => s as PilotConfSoftwareId),
    csCreationDatetime: z.coerce.date(),
    csId: z
      .number()
      .transform((s) => s as PilotCsId)
      .nullable(),
    hwId: z.number().transform((s) => s as PilotHwId),
    lastIpDate: z.coerce.date().nullable(),
    location: z.string().nullable(),
    operator: z.string(),
    momboxHardwareVersion: z.object({
      id: z.number(),
      description: z.string(),
      v2V5: z.boolean(),
      vx: z.boolean(),
    }),
    /**
     * Ça ne s'invente pas, les valeurs en BDD de refOperatingStatus
     * 1,Vert
     * 2,Orange
     * 3,Rouge
     */
    refOperatingStatus: z.number(),
    serialNumber: z.string().transform((s) => s as SerialNumber),
    siteId: z
      .number()
      .transform((s) => s as SiteId)
      .nullable(),
    softwareVersion: z.string(),
    updating: z.boolean(),
    versionAction: z.unknown().nullable(),
  }),
);

export type BackofficeFindPilotResponse = z.infer<typeof backofficeFindPilotResponseSchema>;
